export enum ProSkillAssureDetailTabMenuType {
  INFORMATION = "information",
  CANDIDATES = "candidates"
}